import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const remarksActivityFragment = gql`
  fragment remarksActivityFragment on Activity {
    _id
    activity
    by {
      _id
      profile {
        _id
        name
        picture
      }
    }
    updatedAt
    isDeleted
  }
`

export const membersFragment = gql`
  fragment membersFragment on User {
    _id
    profile {
      _id
      name
      email
      picture
    }
    company {
      _id
      name
    }
    phone
    remarks
    tags
    address {
      _id
      fullAddress
    }
  }
`

export const purchaseOrderFragment = gql`
  fragment purchaseOrderFragment on PurchaseOrder {
    _id
    summary
    code
    status
    purchaseDate
    updatedAt
    createdAt
    estimatedArrivalDate
    net
    shipVia
    vendor {
      _id
      profile {
        _id
        name
        picture
        email
      }
      status
      company {
        _id
        name
        domain
      }
      phone
      address {
        _id
        street1
        street2
        city
        state
        zip
        fullAddress
        country
      }
      addresses {
        _id
        street1
        street2
        city
        state
        zip
        fullAddress
        country
        status
      }
    }
    shipTo {
      _id
      profile {
        _id
        name
        picture
        email
      }
      status
      company {
        _id
        name
        domain
      }
      phone
      address {
        _id
        street1
        street2
        city
        state
        zip
        fullAddress
        country
      }
      addresses {
        _id
        street1
        street2
        city
        state
        zip
        fullAddress
        country
        status
      }
    }
    vendorAddress {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone
    }
    items {
      _id
      product {
        _id
        code
        name
        coverImage
        coverImageThumb
        status
        inventory {
          _id
          quantityOnHand
        }
        inStock
        requiredComputedQuantityOnHand
        hasSubComponents
        productType
        requiredSerialNumber
        serialNumberType
        baseUom {
          _id
          code
          symbol
        }
        unitOfMeasurePrecision
        purchaseConversionFactor
        metadata {
          _id
          key
          value
          unit
        }
        vendors {
          _id
          vendorCode
          price
          vendor {
            _id
          }
          url
        }
      }
      quantity
      price
      net
      remarks
      tags
      discount
      originalPrice
      vendorProductCode
      inventoryCount
      uom {
        _id
        code
        name
        symbol
      }
    }
    gross
    remarks
    tags
    taxAmount
    discount
    discountPercent
    payments {
      _id
      status
      date
      method
      remarks
      merchantFee
      net
      gross
      refunds {
        _id
        amount
        remarks
        date
      }
      relatedOrderId
    }
    communication {
      _id
      email {
        _id
        to
        from
        timeStamp
        content
      }
    }
    shipToAddress {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      company
      street3
      name
      phone
    }
    paymentStatus
    paymentTerms
    activeConversationId
    paymentBalance {
      _id
      balance
      totalPaid
    }
    remarksActivity {
      ...remarksActivityFragment
    }
    relatedWorkOrders {
      _id
      code
      status
    }
    poNotes
    members {
      ...membersFragment
    }
    assets {
      _id
      title
      subtitle
      url
      type
    }
  }

  ${remarksActivityFragment}
  ${membersFragment}
`

export const purchaseOrderQuery = buildGraphqlQuery('PurchaseOrder', purchaseOrderFragment, [
  'items',
  'relatedWorkOrders',
])

export const purchaseOrderListFragment = gql`
  fragment purchaseOrderListFragment on PurchaseOrder {
    _id
    code
    purchaseDate
    estimatedArrivalDate
    status
    net
    gross
    remarks
    tags
    taxAmount
    discount
    paymentStatus
    paymentTerms
    vendor {
      _id
      phone
      company {
        _id
        name
      }
      profile {
        _id
        email
        name
      }
    }
    remarksActivity(filter: {}, options: { sort: { updatedAt: -1 }, limit: 10 }) {
      ...remarksActivityFragment
    }
  }
  ${remarksActivityFragment}
`
export const purchaseOrderListQuery = buildGraphqlQuery('PurchaseOrder', purchaseOrderListFragment, ['items'])

export const vendorAddressesQuery = gql`
  query vendorAddresses($filter: JSON, $options: JSON) {
    vendorAddresses(filter: $filter, options: $options) {
      _id
      street1
      street2
      city
      state
      zip
      country
      fullAddress
      type
      street3
      company
      name
      phone
    }
  }
`

export const singlePurchaseOrderQuery = gql`
  query singlePurchaseOrder($filter: JSON) {
    singlePurchaseOrder(filter: $filter) {
      ...purchaseOrderFragment
    }
  }
  ${purchaseOrderFragment}
`
